import Box from "@mui/material/Box";

import DeleteRiskButton from "./DeleteRiskButton";

type RiskActionsProps = {
  riskId: string;
  refetchRisk: () => void;
};

export default function RiskActions({ riskId, refetchRisk }: RiskActionsProps) {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
      <DeleteRiskButton rowSelection={[riskId]} refetchRisk={refetchRisk} />
    </Box>
  );
}
